import { FunctionalComponent, h } from 'preact';

import { LocationModel } from 'common/data/location/model';
import { BuildingReviewButtonComponentPropsInterface } from 'common/module/building-review/button/component-props.interface';
import { BuildingReviewButtonTemplate } from 'common/module/building-review/button/template';
import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { LocationStoreService } from 'common/service/location-store/service';
import { BuildingReviewButtonViewStoreFactory } from 'desktop/module/building-review/button/view-store.factory';

const BuildingReviewButton = preactDynamicComponent(BuildingReviewButtonTemplate);

let location = new LocationModel();

export const BuildingReviewLandingWriteReviewComponent: FunctionalComponent<BuildingReviewButtonComponentPropsInterface> =
  (props) => {
    if (props.locationId) {
      location = LocationStoreService().getOneById(props.locationId) || location;
    }
    const viewStore = BuildingReviewButtonViewStoreFactory(!!location.id);
    const element = document.createElement('div');

    viewStore.initialize({
      location,
      element,
      hasAutocomplete: !location.id,
      hasModalAutoOpening: props.hasAutoOpening,
    });

    return <BuildingReviewButton viewStore={viewStore}>{props.children}</BuildingReviewButton>;
  };
